import { StandardFilterType } from '../StandardFilterType';

export const getStandardTypeFilterValue = (customScoreNumber: number): StandardFilterType => {
    return ({
        1: StandardFilterType.custom1,
        2: StandardFilterType.custom2,
        3: StandardFilterType.custom3,
    })[customScoreNumber];
};
